export interface Storager {
    setElement(key: string, obj: any, encoded?: boolean): void;
    getElement(key: string, encoded?: boolean): any;
    removeElement(key: string): void;
    clearAll(): void;
    hasElement(key: string): boolean;
}
